import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight, FaBars } from 'react-icons/fa';
import { associateSearch } from '../associateNavigation';
import { dashboardText } from './dashboardText';
import { roleDisplayLabel } from '../../../utils/roleDisplayLabel';

export default function AssociateDashboardShell({ infoSource, items, activeTab, onSelect, children, contentRef }) {
  const location = useLocation();
  const t = dashboardText(infoSource);
  const current = items.find(item => item.key === activeTab) || items[0];
  const change = item => { onSelect(item.key); item.onSelect?.(); };
  return <div className="aa-shell aa-dashboard" ref={contentRef}>
    <aside className="aa-sidebar">
      <div className="aa-nav-heading"><span className="aa-brand-mark">E</span><div><strong>Elakay</strong><small>{t('workspace')}</small></div></div>
      <nav aria-label={t('navigation')}>
        {items.map(item => <Link key={item.key} to={{ pathname: location.pathname, search: associateSearch(location.search, item.key) }}
          className={`aa-nav-link ${activeTab === item.key ? 'active' : ''}`} aria-current={activeTab === item.key ? 'page' : undefined}
          onClick={event => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault(); change(item);
          }}><span className="aa-nav-icon">{item.icon}</span><span>{item.label}</span>{activeTab === item.key && <FaChevronRight className="aa-nav-arrow" />}</Link>)}
      </nav>
    </aside>
    <main className="aa-content">
      <header className="aa-page-header">
        <div><div className="aa-breadcrumb">Elakay <FaChevronRight /> {t('workspace')}</div>
          <h1>{current.label}</h1><p>{t(`${activeTab}Description`)}</p></div>
        <span className="aa-role-badge">{roleDisplayLabel(infoSource?.userInfo?.userActiveRole?.roleName || infoSource?.userRole?.roleName)}</span>
      </header>
      <label className="aa-mobile-navigation"><span><FaBars />{t('navigation')}</span>
        <select value={activeTab} onChange={event => change(items.find(item => item.key === event.target.value))}>
          {items.map(item => <option value={item.key} key={item.key}>{item.label}</option>)}
        </select>
      </label>
      <div className={`aa-page-panel aa-tab-${activeTab}`}>{children}</div>
    </main>
  </div>;
}
